import { BodyLink } from '@jouzen/ecom-components/v3/BodyLink';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import type { JSX } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

interface UpgradeWarrantyBenefitsReturn {
  name: string;
  ListItem: JSX.Element;
}

const upgradeWarrantyBenefits = (
  t: (str: MessageKey) => string,
): UpgradeWarrantyBenefitsReturn[] => [
  {
    name: 'damage_and_battery',
    ListItem: (
      <Typography className="text-sm">{t('damage_and_battery')}</Typography>
    ),
  },
  {
    name: 'mechanical_and_electrical',
    ListItem: (
      <Typography className="text-sm">
        {t('mechanical_and_electrical')}
      </Typography>
    ),
  },
  {
    name: 'simple_online_claims',
    ListItem: (
      <Typography className="text-sm">{t('simple_online_claims')}</Typography>
    ),
  },
  {
    name: 'zero_deductible',
    ListItem: (
      <Typography className="text-sm">{t('zero_deductible')}</Typography>
    ),
  },
  {
    name: 'free_shipping_for_replacement',
    ListItem: (
      <Typography className="text-sm">
        {t('free_shipping_for_replacement')}
      </Typography>
    ),
  },
  {
    name: 'details_and_faq',
    ListItem: (
      <BodyLink
        className="text-sm"
        href="https://customers.extend.com/en-US/plan_details/A0-oura-3y?storeId=4a821e29-c414-45d5-b663-15c4ecf082b6"
        target="_blank"
      >
        {t('details_and_faq')}
      </BodyLink>
    ),
  },
];

export default upgradeWarrantyBenefits;
